@switch (mdTask.status) { @case ('completed') {
<alaris-tag [dot]="true" mode="success">{{ 'manual_dipping.statuses.completed' | translate }}</alaris-tag>
} @case ('in_progress') {
<alaris-tag [dot]="true" mode="info">{{ 'manual_dipping.statuses.in_progress' | translate }}</alaris-tag>
} @case ('failed') {
<alaris-tag [dot]="true" mode="error">{{ 'manual_dipping.statuses.failed' | translate }}</alaris-tag>
} @default {
<alaris-tag [dot]="true" mode="error"></alaris-tag>
} }
